<style>
    .curator-io-feed{
        position:relative;
    }
    .curator-io-feed.editing{
        height:500px;
        overflow:hidden;
    }
    .curator-io-feed.editing:after{
        content: '';
        height:500px;
        position:absolute;
        left: 0; top :0;
        width:100%; height:100%;
        background:transparent;
        display:block;
        z-index:1;
    }
</style>

<template>
    <div class="curator-io-feed" :class="{editing : this.$root.edit}">
        <div v-if="feed_id != ''" :id="container_id">
            <a href="https://curator.io" target="_blank" class="crt-logo crt-tag">Powered by Curator.io</a>
        </div>
        <div v-if="feed_id == ''">
            <strong>Curator.io</strong> är en tjänst som låter dig hämta innehållet från dina olika sociala medier och visa dem på din hemsida. Det är gratis för en sida och begränsat antal utseenden, men du kan testa först och uppgradera senare på <a href="https://curator.io">curator.io</a>. När du skaffat ett konto, fyller du i ditt "Feed Public Key" som du hittar under "Publicera" samt om du bytt ditt Container ID (normalt <code>{{container_id}}</code>).
        </div>
    </div>
</template>

<script>
export default {
    name: 'zoezi-curator-io',
    zoezi: {
        title: 'Curator.io',
        icon: 'mdi-instagram'
    },
    props: {
        container_id: {
            title: 'Container ID',
            type: String,
            default: 'curator-feed-default-feed-layout'
        },
        feed_id: {
            title: 'Feed Public Key',
            type: String,
            default: ''
        },
    },
    data: () => ({}),
    mounted() {
        if(this.feed_id.length > 0){
            let recaptchaScript = document.createElement('script')
            recaptchaScript.setAttribute('src', 'https://cdn.curator.io/published/' + this.feed_id + '.js')
            document.head.appendChild(recaptchaScript)
        }
    }
}</script>
